import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AbilitiesSelectors } from '@core/abilities-data';
import { Ability } from '@core/abilities-types';
import { DisqualifyReasonsSelectors } from '@core/disqualify-reasons-data';

@Injectable({
  providedIn: 'root',
})
export class DisqualifyCandidateActionDataFacade {
  private readonly store = inject(Store);

  public disqualifyReasons = this.store.selectSignal(
    DisqualifyReasonsSelectors.entitiesWithReferences(),
  );

  public hasManageDisqualifyReasons = this.store.selectSignal(
    AbilitiesSelectors.hasOne(Ability.ManageDisqualifyReasons),
  );
}
